import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { Col, Row } from "@pds-react/grid";
import { fetchService } from "../../../services/fetchService";
import Config from "../../../config";
import UserContext from "../../../context/User.context";
import {
  createColumnHelper,
  useReactTable,
  getCoreRowModel,
  flexRender,
  getPaginationRowModel,
} from "@tanstack/react-table";
import { Link } from "react-router-dom";
import Button from "@pds-react/button";
import Input from "@pds-react/input";
import "./CustodyAccountManagement.scss";

import { useNavigate } from "react-router-dom";
import Loading from "../../Loading/Loading";
import Pagination from "../Pagination";
import BasicTable from "../BasicTable";
import { customStyles } from "../helpers";

let columns = [];
const columnHelper = createColumnHelper();

const columnsLong = [
  columnHelper.accessor("custody_account", {
    header: () => "Account Number",
  }),
  columnHelper.accessor("custody_account_suffix", {
    header: () => "Account Number Suffix",
  }),
  columnHelper.accessor("threshold_amount", {
    header: () => "Threshold Value",
  }),
  columnHelper.accessor("start_date", {
    header: "Start Date",
  }),
  columnHelper.accessor("end_date", {
    header: "End Date",
  }),
];

const CustodyAccountManagement = () => {
  const { baseUrl } = Config.api;
  const { accessToken } = useContext(UserContext);
  const [isloadingActive, setLoadingActive] = useState(true);
  const navigate = useNavigate();
  console.log("Inside Custody Account Management");

  const [custodyAccountType, setContactType] = useState({
    label: "All",
    value: "all",
  });
  columns = columnsLong;

  const [dataActive, setDataActive] = useState([]);

  const [pageViewNum, setPageViewNum] = useState({ value: "", label: "" });

  const tableActive = useReactTable({
    data: dataActive,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  const initialFilters = {
    custody_account_input: "",
  };
  const [filters, setFilters] = useState(initialFilters);
  const { custody_account_input } = filters;

  const getTableData = async () => {
    console.log("Trying to get data");
    try {
      setLoadingActive(true);
      let endpoint = "";

      if (custodyAccountType.value == "closed") {
        endpoint = `/gmmCustodyAccountMaster/closed`;
      } else if (custodyAccountType.value == "inactive") {
        endpoint = `/gmmCustodyAccountMaster/inactive`;
      } else if (custodyAccountType.value == "active") {
        endpoint = `/gmmCustodyAccountMaster/active`;
      } else {
        endpoint = `/gmmCustodyAccountMaster`;
      }
      setLoadingActive(false);

      if (endpoint) {
        let response = await fetchService(baseUrl + endpoint, { method: "GET", token: accessToken });
        let resp = await response.json();
        if (200 !== response.status) {
          throw new Error(resp.requestId);
        }
        setDataActive(
          resp
            .map((result) => {
              return {
                custody_account: result.CustodyAccount,
                custody_account_suffix: result.CustodyAccountSuffix,
                start_date: result.StartDate,
                end_date: result.EndDate,
                threshold_amount: result.ThresholdAmount,
              };
            })
            .filter((singleRow) => singleRow.custody_account.includes(custody_account_input))
        );
        setLoadingActive(false);
      }
    } catch (error) {
      navigate("/error", { state: { error } });
    }
  };

  const handleViewChange = (e) => {
    setContactType((prevGroupings) => ({ ...prevGroupings, label: e.label, value: e.value }));
  };

  const getPageViewOption = (numberOfPages) => {
    let choices = [];
    for (let i = 1; i < numberOfPages + 1; i++) {
      choices.push({ value: i - 1, label: i });
    }
    return choices;
  };

  const handleChange = (e, id) => {
    const value = e.target.value;
    setFilters((filter) => ({ ...filter, [id]: value }));
  };

  useEffect(() => {
    (async () => {
      await getTableData();
    })();
  }, [custodyAccountType]);

  return (
    <div data-testid={"custody-account-management-view"}>
      <Col>
        <Row>
          <Col data-testid={"header"} id={"header"}>
            <h2>Custody Account Management</h2>
          </Col>
        </Row>
        <Row className="util-margin-top-sm-15 util-margin-top-xs-30">
          <Col sm={6}>
            <Button
              data-testid={"create_button"}
              id={"create_button"}
              onClick={() => {
                navigate("/custody-account-details/new");
              }}
            >
              Create Custody Account
            </Button>
          </Col>
          <Col sm={3} style={{ textAlign: "right", marginTop: "2rem", paddingRight: "0px" }}>
            <span>View</span>
          </Col>
          <Col sm={3} id={"View"} data-testid={"View"}>
            <Select
              styles={customStyles}
              value={custodyAccountType}
              onChange={(e) => {
                handleViewChange(e);
              }}
              options={[
                { label: "All", value: "all" },
                { label: "Active", value: "active" },
                { label: "Inactive", value: "inactive" },
                { label: "Closed", value: "closed" },
              ]}
            ></Select>
          </Col>
        </Row>
        <Row>
          <Col data-testid={"header"} id={"header"}>
            <h3>Custody Accounts</h3>
          </Col>
        </Row>
        {!isloadingActive ? (
          <>
            <Row className={"util-padding-top-20"}>
              <Col>
                <table data-testid={"management_table"} id={"management_table"}>
                  <colgroup>
                    <col style={{ width: 15 }} />
                    <col style={{ width: 10 }} />
                    <col style={{ width: 10 }} />
                    <col style={{ width: 10 }} />
                    <col style={{ width: 10 }} />
                    <col style={{ width: 10 }} />
                  </colgroup>
                  <thead>
                    {tableActive.getHeaderGroups().map((headerGroup) => (
                      <tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                          <th key={header.id}>
                            {header.isPlaceholder
                              ? null
                              : flexRender(header.column.columnDef.header, header.getContext())}
                          </th>
                        ))}
                        <th>Actions</th>
                      </tr>
                    ))}
                    <tr>
                      <th>
                        <Input
                          id="custody_account_input"
                          data-testid={"custody_account_input"}
                          label=""
                          value={custody_account_input}
                          style={{ display: "inline-block" }}
                          onChange={(e) => {
                            handleChange(e, "custody_account_input");
                          }}
                        ></Input>
                        <Button
                          style={{
                            borderRadius: 10,
                            margin: "5%",
                            width: "40%",
                            height: "40px",
                            display: "inline-block",
                            padding: "0px",
                          }}
                          className="pds-button pds-button-secondary-ghost"
                          data-testid={"filter_button"}
                          id={"filter_button"}
                          onClick={async () => {
                            await getTableData();
                          }}
                        >
                          Filter
                        </Button>
                      </th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataActive.length < 1 ? (
                      <>
                        <tr>
                          {columns.map((col, index) => (
                            <td key={index}>&#8205;</td>
                          ))}
                        </tr>
                      </>
                    ) : (
                      <>
                        {tableActive.getRowModel().rows.map((row) => (
                          <tr key={row.id}>
                            {row.getVisibleCells().map((cell) => (
                              <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                            ))}
                            <td key={row.id} style={{ textAlign: "right" }}>
                              <>
                                {" "}
                                Custody Account:{" "}
                                <Link
                                  id={"company_details_edit_link"}
                                  data-testid={"company_details_edit_link"}
                                  to={`/custody-account-details/edit/${dataActive[row.id].custody_account}`}
                                >
                                  Edit
                                </Link>
                              </>
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </table>
              </Col>
            </Row>
            <Pagination
              data={dataActive}
              table={tableActive}
              setPageViewNum={setPageViewNum}
              pageViewNum={pageViewNum}
              getPageViewOption={getPageViewOption}
            ></Pagination>
          </>
        ) : (
          <>
            <h2 className="text-center"> Application is starting</h2>
            <Loading></Loading>
          </>
        )}
      </Col>
    </div>
  );
};

export default CustodyAccountManagement;
